// extracted by mini-css-extract-plugin
module.exports = {"tr":"TrComponent_tr__uLKCN","expanded":"TrComponent_expanded__2RtkP"};